var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRetirement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 67 67",
    style: {
      enableBackground: "new 0 0 67 67"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E3F2FF;}\n\t.st1{fill:#4343B5;}\n\t.st2{fill:#A6A6F7;}\n\t.st3{fill:#7ADDB6;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1076",
    transform: "translate(0.975 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_885"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.8,9.3c-0.5,0-1-0.4-1-1V6c0-0.5,0.4-1,1-1c0.5,0,1,0.4,1,1v2.3C44.8,8.8,44.4,9.3,43.8,9.3 C43.8,9.3,43.8,9.3,43.8,9.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M43.8,10.1L43.8,10.1c-1,0-1.8-0.8-1.8-1.8V6c0-1,0.8-1.8,1.8-1.8c1,0,1.8,0.8,1.8,1.8v2.3 C45.6,9.3,44.8,10.1,43.8,10.1L43.8,10.1z M43.8,5.9c-0.1,0-0.1,0.1-0.1,0.1v2.3c0,0.1,0.1,0.1,0.1,0.1c0.1,0,0.1-0.1,0.1-0.1V6 C44,6,43.9,5.9,43.8,5.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_886"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M40.9,23.3h5.8V48h-5.8V23.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.6,48.9h-7.5V22.5h7.5V48.9z M41.8,47.2h4.2v-23h-4.2V47.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_887"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M43.8,8.3c-10.4,0-18.7,6.1-21.1,13.5c-0.6,1.8,0.4,3.6,2.2,4.2c0.3,0.1,0.7,0.2,1,0.2h7.4 c1.7,0,3.2-1.3,3.3-3.1C37,18.3,38.5,11.1,43.8,8.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.4,27C33.4,27,33.4,27,33.4,27h-7.5c-0.4,0-0.8-0.1-1.3-0.2c-1.1-0.3-1.9-1.1-2.4-2.1 c-0.5-1-0.6-2.1-0.3-3.2c2.7-8.3,11.7-14.1,21.9-14.1l0.4,1.6c-4.9,2.5-6.3,9.1-6.7,14.1C37.4,25.3,35.6,27,33.4,27z M41,9.3 c-8.3,0.9-15.3,5.9-17.5,12.8c-0.2,0.6-0.1,1.3,0.2,1.9s0.8,1,1.5,1.2c0.2,0.1,0.5,0.1,0.7,0.1h7.4c0,0,0,0,0,0 c1.3,0,2.4-1,2.5-2.3C36.2,18.5,37.4,12.8,41,9.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_888"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M43.8,8.3c10.4,0,18.7,6.1,21.1,13.5c0.6,1.8-0.4,3.6-2.2,4.2c-0.3,0.1-0.7,0.2-1,0.2h-7.4 c-1.7,0-3.2-1.3-3.3-3.1C50.6,18.3,49.2,11.1,43.8,8.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M54.3,27c-2.2,0-4-1.7-4.1-3.8c-0.4-5-1.8-11.6-6.7-14.1l0.4-1.6c10.2,0,19.2,5.8,21.9,14.1 c0.3,1.1,0.2,2.2-0.3,3.2c-0.5,1-1.4,1.7-2.4,2.1c-0.4,0.1-0.8,0.2-1.3,0.2H54.3L54.3,27z M46.7,9.3c3.6,3.4,4.8,9.2,5.2,13.7 c0.1,1.3,1.2,2.3,2.5,2.3c0,0,0,0,0,0h7.4c0.3,0,0.5,0,0.7-0.1c0.6-0.2,1.2-0.6,1.5-1.2s0.4-1.3,0.2-1.9 C61.9,15.2,55,10.2,46.7,9.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_889"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M51,22.6C50.5,17.8,49,11,43.9,8.3c-5.2,2.7-6.7,9.5-7.1,14.3c-0.2,1.8,1.2,3.4,3,3.6c0.1,0,0.2,0,0.3,0h7.6 c1.8,0,3.3-1.5,3.3-3.3C51,22.7,51,22.7,51,22.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.6,27h-7.6c-0.1,0-0.2,0-0.4,0c-1.1-0.1-2.1-0.6-2.8-1.5c-0.7-0.8-1.1-1.9-1-3c0.7-7.5,3.3-12.7,7.6-14.9 l0.4-0.2l0.4,0.2c5.4,2.8,7.1,9.7,7.5,14.9l0,0c0,0.1,0,0.2,0,0.3C51.8,25.1,49.9,27,47.6,27z M43.9,9.3 c-4.4,2.6-5.9,8.7-6.3,13.4c-0.1,0.7,0.1,1.3,0.6,1.8c0.4,0.5,1,0.8,1.7,0.9c0.1,0,0.1,0,0.2,0h7.6c1.4,0,2.5-1.1,2.5-2.5 c0-0.1,0-0.1,0-0.2C49.7,17.9,48.3,11.9,43.9,9.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_890"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M50.8,52.2h4.7l3,6.7c0.2,0.4,0,0.8-0.4,1c-0.1,0-0.2,0.1-0.3,0.1h-3.3c-0.4,0-0.9-0.3-1-0.7L50.8,52.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M54.6,60.7c-0.8,0-1.5-0.5-1.8-1.2l-3.3-8.2h6.5l3.2,7.2c0.4,0.8,0,1.7-0.8,2.1c-0.2,0.1-0.5,0.1-0.6,0.1 H54.6C54.7,60.7,54.6,60.7,54.6,60.7z M52.1,53l2.4,5.9c0,0.1,0.1,0.2,0.2,0.2c0,0,0,0,0,0h3.1L55,53H52.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_891"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M29.3,52.2h-4.7l-3,6.7c-0.2,0.4,0,0.8,0.4,1c0.1,0,0.2,0.1,0.3,0.1h3.3c0.4,0,0.9-0.3,1-0.7L29.3,52.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.5,60.7C25.5,60.7,25.5,60.7,25.5,60.7h-3.3c-0.2,0-0.4,0-0.6-0.1c-0.4-0.2-0.7-0.5-0.8-0.9 c-0.1-0.4-0.1-0.8,0-1.2l3.2-7.2h6.5l-3.3,8.2C27,60.3,26.3,60.7,25.5,60.7z M25.1,53l-2.7,6.1l3.1,0c0,0,0,0,0,0 c0.1,0,0.2-0.1,0.2-0.2l2.4-5.9H25.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_892"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.6,54.6H24c-2.2,0-4.2-0.9-5.8-2.4L0.9,34.9c-1.3-1.3-1.2-3.4,0.1-4.7c1.3-1.2,3.3-1.2,4.6,0l17.4,17.4 c0.3,0.3,0.7,0.5,1.1,0.5h35.6c1.8,0,3.3,1.5,3.3,3.3C62.9,53.2,61.4,54.6,59.6,54.6C59.6,54.6,59.6,54.6,59.6,54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24,55.5c-2.4,0-4.7-1-6.3-2.6L0.3,35.5c-0.8-0.8-1.2-1.8-1.2-3c0-1.1,0.5-2.1,1.3-2.9c1.6-1.6,4.1-1.6,5.8,0 L23.5,47c0.1,0.1,0.3,0.2,0.5,0.2c0,0,0,0,0,0h35.6c0,0,0,0,0,0c1.1,0,2.1,0.4,2.9,1.2c0.8,0.8,1.2,1.8,1.2,2.9 c0,2.3-1.9,4.1-4.1,4.1H24C24,55.5,24,55.5,24,55.5z M3.3,30.1c-0.6,0-1.2,0.2-1.7,0.7c-0.5,0.5-0.7,1.1-0.7,1.7 c0,0.7,0.2,1.3,0.7,1.8l17.3,17.3c1.4,1.4,3.3,2.1,5.2,2.1h35.6c1.4,0,2.5-1.1,2.5-2.5c0-0.7-0.3-1.3-0.7-1.7 c-0.5-0.5-1.1-0.7-1.7-0.7c0,0,0,0,0,0H24c0,0,0,0,0,0c-0.6,0-1.2-0.3-1.7-0.7L5,30.8C4.5,30.4,3.9,30.1,3.3,30.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_893"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M44.6,53.5c-0.5,0-1.1-0.2-1.5-0.6L34,43.7c-0.1-0.1-0.3-0.2-0.5-0.2H12.2c-1.1,0-2.1-0.9-2.1-2.1 c0-1.1,0.9-2.1,2.1-2.1h21.4c1.3,0,2.5,0.5,3.4,1.4l9.1,9.1c0.8,0.8,0.8,2.1,0,2.9c0,0,0,0,0,0C45.7,53.2,45.2,53.5,44.6,53.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.6,54.3C44.6,54.3,44.6,54.3,44.6,54.3c-0.8,0-1.5-0.3-2.1-0.8l-9.1-9.1H12.2c-1.6,0-2.9-1.3-2.9-2.9 c0-1.6,1.3-2.9,2.9-2.9h21.4c1.5,0,2.9,0.6,4,1.6l9.1,9.1c1,1,1.1,2.7,0.2,3.8v0l-0.1,0.1c0,0-0.1,0.1-0.1,0.1 C46.1,54,45.4,54.3,44.6,54.3z M33.6,42.7c0.4,0,0.8,0.2,1,0.4l9.1,9.1c0.2,0.2,0.5,0.4,0.9,0.4h0c0.2,0,0.4-0.1,0.6-0.2v-0.1 l0.3-0.2c0.4-0.5,0.4-1.2-0.1-1.6l-9.1-9.1c-0.7-0.7-1.7-1.1-2.8-1.1c0,0,0,0,0,0H12.2c-0.7,0-1.2,0.6-1.2,1.2 c0,0.7,0.6,1.2,1.2,1.2H33.6C33.6,42.7,33.6,42.7,33.6,42.7z M33.6,44.4C33.6,44.4,33.6,44.4,33.6,44.4L33.6,44.4z M33.4,44.3 C33.4,44.3,33.4,44.3,33.4,44.3L33.4,44.3z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetirement);
export default __webpack_public_path__ + "static/media/retirement.1da87f2b59afa419b96c69b951090b35.svg";
export { ForwardRef as ReactComponent };